import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Button from 'flarum/common/components/Button';

import CambiarPasswordModal from './components/CambiarPasswordModal';

/**
 * Configuración → «Cambiar contraseña» abre NUESTRO modal (PKG-FORO-PASSWORD-SETTINGS-UX).
 *
 * El botón del core abre `ChangePasswordModal`, que no cambia nada: manda el correo de
 * recuperación y se cierra sin confirmar. Aquí se conserva el botón —mismo sitio, misma
 * prioridad, mismo rótulo del core (`change_password_button`), que ya está traducido y no
 * es copy nuestro— y se le cambia SOLO el destino. `setContent` respeta la posición; si otro
 * día el core renombrara el item, el guard hace que simplemente no toquemos nada en vez de
 * añadir un botón duplicado.
 */
export default function addPasswordSettings() {
  extend(SettingsPage.prototype, 'accountItems', function (items: any) {
    if (!items.has('changePassword')) return;

    items.setContent(
      'changePassword',
      <Button className="Button" onclick={() => app.modal.show(CambiarPasswordModal)}>
        {app.translator.trans('core.forum.settings.change_password_button')}
      </Button>
    );
  });
}
